export function notificationUnreadNotificationCount(state) {
  return state.notification.unreadCount
}